export default __webpack_public_path__ + "static/media/tour.c1f978f5.png";